// extracted by mini-css-extract-plugin
export var checkbox = "_2d-0";
export var circle = "_2d-3";
export var horizontalContainer = "_2d-7";
export var sm = "_2d-5";
export var switch0 = "_2d-2";
export var switchDisabled = "_2d-8";
export var switchEnabled = "_2d-1";
export var textSwitchContainer = "_2d-9";
export var textSwitchOption = "_2d-a";
export var textSwitchOptionSelected = "_2d-b";
export var verticalContainer = "_2d-6";
export var xs = "_2d-4";